import Vue from 'vue'
import App from './App.vue'


import axios from '../node_modules/axios'
Vue.prototype.$axios = axios;
axios.defaults.baseURL = 'http://162.241.29.169:8080/';

//axios.defaults.baseURL = 'http://localhost:8080/';

//导入router
import router from './router'

Vue.config.productionTip = false



new Vue({
router, //挂载
  render: h => h(App),
}).$mount('#app')